import sensors from "sa-sdk-javascript";
const test_url = "http://datasink.xunfuaitech.com/sa?project=default";
const server_url = "https://datasink.xunfuaitech.com/sa?project=production";

sensors.init({
  server_url: window.location.protocol === "http:" ? test_url : server_url,
  is_track_single_page: true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
  use_client_time: true,
  send_type: "beacon",
  show_log: true,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "not_collect",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect",
  },
});
// 公共属性（可选）
sensors.registerPage({
  current_url: window.location.href,
  referrer: document.referrer,
  platform_type: "H5",
  is_register: true,
});

sensors.quick("autoTrack"); //用于采集 $pageview 事件。

export default sensors;
